import { Injectable } from '@angular/core';
import { HTTP,HTTPResponse } from '@ionic-native/http';
import { ConfigurationManager } from './ConfigurationManager';

@Injectable()
export class SearchResultsService {

  all_deals_encoded = 'All+Deals';

  constructor(private http: HTTP, private config: ConfigurationManager) { }

  getResults(data, pageno) {
    const headers = {
      'Content-Type': 'application/json',
      'x-api-key': this.config.environmentConfig.apikey,
      'Accept': 'application/json'
    };

    let url = this.config.environmentConfig.baseurl + 'deser/v1?';
    url = url + 'Latitude=' + this.config.getLatitude;
    url = url + '&Longitude=' + this.config.getLongitude;
    url = url + '&ScreenTitle=' + data.ScreenTitle;
    url = url + '&SessionID=' + this.config.getSessionId;
    url = url + '&ProxyUI=' + this.config.getProxyUI;
    url = url + '&ClubID=' + this.config.getClubCode;
    url = url + '&FromNewDNR=true';
    url = url + '&SearchTypeID=' + data.SearchTypeID;
    url = url + '&PageSize=20';
    url = url + '&Page=' + pageno;
    if (data.keyword) {
      url = url + '&Keyword=' + data.keyword;
    }
    if (data.TravelStartDate) {
      url = url + '&TravelStartDate=' + data.TravelStartDate;
    }
    if (data.DestinationID) {
      url = url + '&DestinationID=' + data.DestinationID;
    }
    return this.http.get(url, {}, headers);

  }
}
